/*
 * Shirt Journey look. The stage stays put while the page scrolls past it: every step turns the shirt
 * to the next product, the big word behind it flips letter by letter, the label on the left rolls
 * to the new name. The entry draws the mark pressed into the stage and lights it with one sweep.
 * Sizes and add to cart go through Shopify's cart and the theme's cart drawer.
 */
(function () {
  'use strict';

  var root = document.querySelector('.a2s-journey[data-a2-look]');
  if (!root) return;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var coarse = window.matchMedia('(pointer: coarse)').matches;
  root.classList.add('sj-js');

  var products = [];
  try {
    products = JSON.parse(root.querySelector('script[data-sj-products]').textContent || '[]');
  } catch (e) {
    products = [];
  }
  var N = products.length;

  var $ = function (sel, el) {
    return (el || root).querySelector(sel);
  };
  var $$ = function (sel, el) {
    return Array.prototype.slice.call((el || root).querySelectorAll(sel));
  };
  var clamp = function (v, a, b) {
    return Math.min(b, Math.max(a, v));
  };
  var smooth = function (a, b, v) {
    var x = clamp((v - a) / (b - a), 0, 1);
    return x * x * (3 - 2 * x);
  };
  var pad = function (n) {
    return String(n).padStart(2, '0');
  };
  var easeOut = function (x) {
    return 1 - Math.pow(1 - x, 3);
  };
  var easeIO = function (x) {
    return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2;
  };
  var shopRoot = (function () {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  })();

  /* ------------------------------------------------------------------ journey */
  var journey = $('[data-sj-journey]');
  var stage = $('[data-sj-stage]');
  var turn = $('[data-sj-turn]');
  var faces = $$('[data-sj-face]', turn);
  var endFace = $('[data-sj-end]');
  if (endFace) faces.push(endFace);
  var ship = root.getAttribute('data-ship') || '';
  var wordsEl = $('[data-sj-words]');
  var hero = $('[data-sj-hero]');
  var label = $('[data-sj-label]');
  var rows = $$('.sj-lm > p', label);
  var elN = $('[data-sj-n]');
  var elOf = $('[data-sj-of]');
  var elName = $('[data-sj-name]');
  var elMeta = $('[data-sj-meta]');
  var details = $('[data-sj-details]');
  var buyBtns = $$('[data-sj-buy-current]');
  var hit = $('.sj-hit');
  var rail = $('[data-sj-rail]');
  var railItems = rail ? $$('li', rail) : [];
  var progress = $('[data-sj-progress]');
  var cue = $('[data-sj-cue]');
  var countWord = root.getAttribute('data-count-word') || String(N);

  // the first scroll already turns the shirt (Nils 04.11.): a short hero, no rest before the first turn
  var HERO = 0.08;
  var END = 0.8;
  var TOTAL = HERO + N + END;
  var perFace = 600;
  var stickyTop = 0;
  var lead = 0;
  var headH = 62;
  var shownHv = -1;
  var stageH = 600;
  var P = -1;
  var introTurn = 0;
  var introFade = 1;
  var heroHeld = false;
  var running = false;
  var last = 0;
  var shownLabel = -99;
  var shownRail = -99;
  var lastQ = NaN;

  // words behind the shirt: intro, one per product, the end
  var wordMap = {};
  (root.getAttribute('data-words') || '').split(/\r?\n/).forEach(function (line) {
    var i = line.indexOf(':');
    if (i < 0) return;
    var handle = line.slice(0, i).trim();
    var rest = line.slice(i + 1).split('|');
    var word = (rest[0] || '').trim();
    if (handle && word) wordMap[handle] = { text: word, font: (rest[1] || '').trim().toLowerCase() === 'graduate' ? 'graduate' : 'futura' };
  });
  function fallbackWord(title) {
    var t = String(title || '')
      .replace(/\s+tee$/i, '')
      .replace(/[·•]/g, ' ')
      .trim()
      .toUpperCase();
    var parts = t.split(/\s+/);
    return t.length > 12 && parts.length > 1 ? parts[parts.length - 1] : t;
  }
  var wordDefs = [{ text: 'SECOND', font: 'futura' }]
    .concat(
      products.map(function (p) {
        var w = wordMap[p.handle] || { text: fallbackWord(p.title), font: 'futura' };
        return { text: w.text, font: w.font };
      })
    )
    .concat([{ text: 'SECOND?', font: 'futura' }]);
  var words = wordDefs.map(function (def) {
    var el = document.createElement('div');
    el.className = 'sj-word';
    el.setAttribute('data-font', def.font);
    var chars = [];
    Array.prototype.forEach.call(def.text, function (ch) {
      var s = document.createElement('span');
      if (ch === ' ') s.className = 'sp';
      else {
        s.className = 'ch';
        s.textContent = ch;
        chars.push(s);
      }
      el.appendChild(s);
    });
    wordsEl.appendChild(el);
    return { el: el, chars: chars, on: false };
  });
  var activeWords = [];

  function fitWords(maxW, maxH) {
    words.forEach(function (w) {
      w.el.style.fontSize = '100px';
      var width = w.el.scrollWidth || 1;
      w.el.style.fontSize = Math.min((maxW / width) * 100, maxH) + 'px';
    });
  }

  var stacked = false;
  function layout() {
    // the shop header scrolls away; the stage sticks to the very top
    var bug = document.querySelector('.a2-bug-wrap');
    headH = bug ? Math.round(bug.getBoundingClientRect().height) : 62;
    var vw = root.clientWidth || window.innerWidth;
    stageH = stage.clientHeight || window.innerHeight - 34;

    var s = Math.min(stageH * 0.8, vw * 0.48, 820);
    var side = (vw - s) / 2;
    stacked = vw < 760 || side < 240;
    var shirtY, wordY, wordMax, wordW;
    if (!stacked) {
      shirtY = (stageH - s) / 2 - stageH * 0.01;
      wordY = shirtY + s * 0.48;
      wordMax = stageH * 0.6;
      wordW = vw * 0.9;
      var gut = clamp(vw * 0.03, 16, 44);
      root.style.setProperty('--sj-side-w', Math.round(Math.min(340, side - gut - 24)) + 'px');
    } else {
      // sized so the intro fits while the shop header is still on screen
      var below = 196;
      var avail = stageH - headH;
      s = Math.min(vw * 0.94, (avail - below - 8) / 0.9, 720);
      var group = 0.9 * s + below;
      // centred once the header is gone, and still whole while it is on screen
      shirtY = Math.max(4, Math.min((stageH - group) / 2, stageH - headH - group - 8));
      wordY = shirtY + s * 0.47;
      wordMax = s * 0.5;
      wordW = vw * 0.96;
      root.style.removeProperty('--sj-side-w');
    }
    s = Math.round(s);
    root.style.setProperty('--sj-s', s + 'px');
    root.style.setProperty('--sj-shirt-y', Math.round(shirtY) + 'px');
    root.style.setProperty('--sj-word-y', Math.round(wordY) + 'px');
    stage.classList.toggle('is-stacked', stacked);
    root.classList.toggle('is-stacked', stacked);
    stage.classList.toggle('is-short', stacked ? stageH < 600 : stageH < 520);

    perFace = Math.round(stageH * (coarse ? 0.62 : 0.7));
    journey.style.height = Math.round(TOTAL * perFace + stageH) + 'px';
    lead = Math.max(0, journeyTop() - stickyTop);
    if (lead > window.innerHeight * 0.6) lead = 0;
    fitWords(wordW, wordMax);
    lastQ = NaN;
    shownLabel = -99;
    kick();
  }

  function journeyTop() {
    return journey.getBoundingClientRect().top + window.scrollY;
  }
  function rawT() {
    // count from the very first scroll even while the stage still slides up under the header (Nils 04.11.)
    var top = journey.getBoundingClientRect().top - stickyTop - lead;
    return clamp(-top / perFace, 0, TOTAL);
  }
  // the shirt rests on each design for a while, then turns
  function settle(r) {
    var e = Math.floor(r);
    var t = r - e;
    var n = e === 0 ? clamp(t / 0.5, 0, 1) : clamp((t - 0.16) / 0.68, 0, 1);
    return e + n * n * n * (n * (n * 6 - 15) + 10);
  }
  function targetP() {
    var t = rawT();
    return t < HERO ? -1 + t / HERO : Math.min(N, settle(t - HERO));
  }

  function setLabel(k) {
    if (k === shownLabel) return;
    shownLabel = k;
    stage.classList.toggle('is-end', k >= N);
    if (k >= N) {
      stage.classList.remove('is-dark');
      elN.textContent = 'Fin.';
      elOf.textContent = '';
      elName.textContent = "That's all " + countWord + '.';
      elMeta.textContent = 'Printed to order';
      if (ship) {
        elMeta.appendChild(document.createElement('br'));
        elMeta.appendChild(document.createTextNode('Ships in ' + ship + ' weeks'));
      }
      buyBtns.forEach(function (b) {
        if (b !== hit) b.textContent = 'See them all';
        b.setAttribute('aria-label', 'See all the shirts');
      });
      if (details) details.hidden = true;
      return;
    }
    var p = products[k];
    if (!p) return;
    stage.classList.toggle('is-dark', !!p.dark);
    elN.textContent = pad(k + 1);
    elOf.textContent = '/ ' + pad(N);
    elName.textContent = p.title;
    setMeta([(p.varies ? 'From ' : '') + p.price, p.color, p.sizes], true);
    buyBtns.forEach(function (b) {
      if (b !== hit) b.textContent = 'Choose size';
      b.setAttribute('aria-label', 'Choose a size: ' + p.title);
    });
    if (details) {
      details.hidden = false;
      details.href = p.url;
      details.setAttribute('aria-label', 'Details: ' + p.title);
    }
  }
  // meta line: parts never break inside, only at the dots
  function setMeta(parts, firstBold) {
    elMeta.textContent = '';
    parts
      .filter(function (x) {
        return !!x;
      })
      .forEach(function (x, i) {
        if (i) {
          var dot = document.createElement('i');
          dot.textContent = '·';
          // the dot stays with the part before it; lines only break after it
          elMeta.appendChild(document.createTextNode('\u00a0'));
          elMeta.appendChild(dot);
          elMeta.appendChild(document.createTextNode(' '));
        }
        var s = document.createElement(i === 0 && firstBold ? 'b' : 'span');
        s.textContent = x;
        elMeta.appendChild(s);
      });
  }
  function setRail(k) {
    var on = k >= 0 && k < N ? k : -1;
    if (on === shownRail) return;
    shownRail = on;
    railItems.forEach(function (li, i) {
      li.classList.toggle('is-on', i === on);
      var b = li.querySelector('button');
      if (b) {
        if (i === on) b.setAttribute('aria-current', 'true');
        else b.removeAttribute('aria-current');
      }
    });
  }

  function render(p) {
    var q = Math.max(0, p) + introTurn;
    var key = p.toFixed(4) + '|' + introTurn.toFixed(4) + '|' + introFade.toFixed(3);
    if (key === lastQ) return;
    lastQ = key;

    // faces
    var poolC = 1;
    faces.forEach(function (f, i) {
      var d = i - q;
      if (reduced) {
        var o = clamp(1 - Math.abs(d), 0, 1);
        f.style.visibility = o > 0.001 ? 'visible' : 'hidden';
        f.style.opacity = o.toFixed(3);
        f.style.transform = '';
        return;
      }
      if (Math.abs(d) >= 0.5) {
        f.style.visibility = 'hidden';
        return;
      }
      var a = d * Math.PI;
      var c = Math.cos(a);
      f.style.visibility = 'visible';
      f.style.transform = 'rotateY(' + (d * 180).toFixed(2) + 'deg) scale(' + (1 - 0.035 * Math.sin(Math.abs(a))).toFixed(4) + ')';
      // full brightness through the whole turn: no grey, no shadow (Nils 04.11.)
      f.style.opacity = '';
      poolC = c;
    });
    stage.style.setProperty('--sj-pool', (0.3 + 0.7 * Math.abs(poolC)).toFixed(3));
    turn.style.opacity = introFade < 1 ? introFade.toFixed(3) : '';

    // intro text, label, rail, progress
    var heroOut = smooth(-0.95, -0.5, p);
    hero.style.opacity = String(1 - heroOut);
    hero.style.visibility = heroHeld || heroOut > 0.99 ? 'hidden' : 'visible';
    hero.style.translate = '0 ' + (-heroOut * 36).toFixed(1) + 'px';
    stage.classList.toggle('is-hero', p < -0.5);
    if (cue) cue.style.opacity = String(1 - smooth(-0.98, -0.75, p));

    var lin = smooth(-0.8, -0.35, p);
    label.style.opacity = String(lin);
    label.classList.toggle('is-on', lin > 0.01);
    var k = clamp(Math.round(p), 0, N);
    setLabel(k);
    var frac = p - Math.round(p);
    if (p < -0.5) frac = 0;
    rows.forEach(function (row, l) {
      var c = reduced ? 0 : smooth(0.08 + l * 0.03, 0.4 + l * 0.025, Math.abs(frac));
      row.style.transform = c ? 'translate3d(0,' + (-Math.sign(frac) * c * 118).toFixed(2) + '%,0)' : '';
      if (reduced) row.style.opacity = String(1 - smooth(0.1, 0.45, Math.abs(frac)));
    });
    if (rail) {
      rail.style.opacity = String(lin);
      rail.style.visibility = lin < 0.01 ? 'hidden' : 'visible';
    }
    setRail(p < -0.5 ? -1 : k);
    if (progress) {
      progress.parentNode.style.opacity = String(lin);
      progress.style.transform = 'scaleX(' + clamp((p + 0.5) / (N + 0.5), 0, 1).toFixed(4) + ')';
    }
    if (hit) hit.setAttribute('aria-label', k < N && products[k] ? 'Choose a size: ' + products[k].title : 'See all the shirts');

    // words
    var e = p;
    var t = Math.round(e);
    var want = [t - 1, t, t + 1].filter(function (a) {
      return a >= -1 && a <= N;
    });
    activeWords.forEach(function (a) {
      if (want.indexOf(a) < 0) {
        words[a + 1].el.classList.remove('is-on');
      }
    });
    want.forEach(function (a) {
      var w = words[a + 1];
      var c = e - a;
      var u = w.chars.length;
      var any = false;
      w.chars.forEach(function (ch, idx) {
        var pos = u > 1 ? idx / (u - 1) : 0.5;
        var g = c >= 0 ? 0.34 + 0.16 * pos : 0.5 - 0.16 * pos;
        var m = c / g;
        if (Math.abs(m) >= 1) {
          ch.style.visibility = 'hidden';
          return;
        }
        any = true;
        ch.style.visibility = 'visible';
        if (reduced) {
          ch.style.transform = '';
          ch.style.opacity = String(1 - Math.abs(m));
        } else ch.style.transform = 'rotateY(' + (m * 90).toFixed(2) + 'deg)';
      });
      w.el.classList.toggle('is-on', any);
    });
    activeWords = want;
    wordsEl.style.opacity = introFade < 1 ? introFade.toFixed(3) : '';
  }

  function frame(now) {
    running = false;
    var dt = clamp((now - last) / 1000 || 0.016, 0.001, 0.05);
    last = now;
    var r = journey.getBoundingClientRect();
    var hv = Math.max(0, Math.round(r.top));
    if (hv !== shownHv) {
      shownHv = hv;
      stage.style.setProperty('--sj-hv', hv + 'px');
    }
    if (r.bottom < -50 || r.top > window.innerHeight + 50) {
      if (entryOn) kick();
      return;
    }
    var tgt = targetP();
    if (reduced) P = tgt;
    else {
      P += (tgt - P) * (1 - Math.exp(-dt * 10));
      if (Math.abs(tgt - P) < 0.0005) P = tgt;
    }
    render(P);
    if (P !== tgt || entryOn) kick();
  }
  function kick() {
    if (running) return;
    running = true;
    window.requestAnimationFrame(frame);
  }

  function goTo(i) {
    var y = journeyTop() - stickyTop - lead + (HERO + i) * perFace + 1;
    window.scrollTo({ top: Math.round(y), behavior: reduced ? 'auto' : 'smooth' });
  }
  if (rail) {
    rail.addEventListener('click', function (e) {
      var b = e.target.closest('[data-sj-go]');
      if (!b) return;
      goTo(parseInt(b.getAttribute('data-sj-go'), 10) || 0);
    });
  }
  function scrollToShop() {
    var shop = document.getElementById('sj-shop');
    if (!shop) return;
    var y = shop.getBoundingClientRect().top + window.scrollY - stickyTop;
    window.scrollTo({ top: Math.round(y), behavior: reduced ? 'auto' : 'smooth' });
  }
  buyBtns.forEach(function (b) {
    b.addEventListener('click', function (e) {
      var k = clamp(Math.round(P), 0, N);
      if (k >= N) {
        scrollToShop();
        return;
      }
      openBuy(k, b, e.detail === 0);
    });
  });

  /* ------------------------------------------------------------------ entry */
  var entry = $('[data-sj-entry]');
  var entryMark = $('[data-sj-entry-mark]');
  var sweep = root.querySelector('.sj-sweep');
  var glint = entry ? entry.querySelector('.sj-glint') : null;
  var entryOn = false;
  var SEEN = 'a2-sj-entry';

  function entrySeen() {
    try {
      return window.sessionStorage.getItem(SEEN) === '1';
    } catch (e) {
      return false;
    }
  }
  function revealHero(delay) {
    if (reduced || !hero.animate) return;
    Array.prototype.forEach.call(hero.children, function (el, i) {
      el.animate(
        [
          { opacity: 0, transform: 'translateY(18px)' },
          { opacity: 1, transform: 'none' },
        ],
        { duration: 900, delay: delay + i * 90, easing: 'cubic-bezier(.2,.7,.2,1)', fill: 'backwards' }
      );
    });
    if (cue && cue.animate) cue.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 900, delay: delay + 500, fill: 'backwards' });
  }

  function runEntry() {
    if (!entry || !entryMark || !sweep || !glint || reduced || entrySeen() || rawT() > 0.05) {
      revealHero(80);
      return;
    }
    try {
      window.sessionStorage.setItem(SEEN, '1');
    } catch (e) {}
    entryOn = true;
    stage.classList.add('is-entry');
    heroHeld = true;
    introFade = 0;
    introTurn = -0.32;
    var X0 = 9.3656;
    var W = 31.7604;
    var SW = W * 1.3;
    var start = performance.now();
    var skipAt = -1;
    var OUT = 2150;
    // the mark then flies up into the header and becomes its logo (Nils 04.11.: "from the middle into the top … super sleek")
    var FLY = 1050;
    var DONE = OUT + Math.max(1300, FLY + 120);
    var brand = document.querySelector('.a2-bug .a2-brand img');
    var flight = null;
    if (brand) brand.style.opacity = '0';
    var SKEW = Math.tan((16 * Math.PI) / 180) * 18;

    function skip() {
      if (skipAt < 0) skipAt = performance.now();
    }
    var opts = { passive: true };
    window.addEventListener('wheel', skip, opts);
    window.addEventListener('touchstart', skip, opts);
    window.addEventListener('keydown', skip);
    window.addEventListener('pointerdown', skip, opts);

    function step(now) {
      var t = now - start;
      if (skipAt >= 0) {
        // fast-forward to the outro
        var since = now - skipAt;
        var at = Math.max(t, OUT);
        t = t < OUT ? OUT + since * 1.6 : at + since * 0.6;
      }
      // pressed mark fades in
      var a = easeOut(clamp(t / 600, 0, 1));
      // light sweep reveals the colour
      var sw = easeIO(clamp((t - 500) / 1200, 0, 1));
      var sx = X0 - SW + sw * (SW + 3);
      sweep.setAttribute('x', (sx + SKEW).toFixed(3));
      var edge = sx + SW * 0.94;
      glint.setAttribute('x', (edge - 1.6 + SKEW).toFixed(3));
      glint.setAttribute('opacity', (sw > 0 && sw < 1 ? Math.sin(sw * Math.PI) : 0).toFixed(3));
      // outro: the mark lifts off and lands on the header logo, the first shirt turns in under the light
      if (t < OUT || !brand) {
        var o = brand ? 0 : easeIO(clamp((t - OUT) / 450, 0, 1));
        entryMark.style.opacity = (a * (1 - o)).toFixed(3);
        entryMark.style.transform = 'translate(-50%,-50%) scale(' + (1.02 - 0.02 * a - 0.04 * o).toFixed(4) + ')';
      } else {
        if (!flight) {
          // out of the stage, so it can travel over the sticky header
          var r0 = entryMark.getBoundingClientRect();
          flight = { x: r0.left, y: r0.top, w: r0.width, h: r0.height };
          document.body.appendChild(entryMark);
          entryMark.style.cssText =
            'position:fixed;left:' + flight.x + 'px;top:' + flight.y + 'px;width:' + flight.w + 'px;height:' + flight.h +
            'px;margin:0;z-index:1000;pointer-events:none;overflow:visible;transform-origin:50% 50%;will-change:transform';
        }
        var f = easeIO(clamp((t - OUT) / FLY, 0, 1));
        var rb = brand.getBoundingClientRect();
        var sc = rb.width / flight.w;
        var dx = rb.left + rb.width / 2 - (flight.x + flight.w / 2);
        var dy = rb.top + rb.height / 2 - (flight.y + flight.h / 2);
        entryMark.style.transform =
          'translate3d(' + (dx * f).toFixed(2) + 'px,' + (dy * f).toFixed(2) + 'px,0) scale(' + (1 + (sc - 1) * f).toFixed(4) + ')';
        // the last moment: the header logo takes over where the mark lands
        var hand = clamp((t - OUT - FLY + 120) / 120, 0, 1);
        brand.style.opacity = hand ? hand.toFixed(3) : '0';
        entryMark.style.opacity = (1 - hand).toFixed(3);
      }
      entry.style.backgroundColor = 'rgba(10,10,12,' + (1 - easeOut(clamp((t - OUT - 250) / 600, 0, 1))).toFixed(3) + ')';
      var s2 = easeOut(clamp((t - OUT - 250) / 950, 0, 1));
      introFade = s2;
      introTurn = -0.32 * (1 - s2);
      lastQ = NaN;
      kick();
      if (t >= OUT + 380 && heroHeld) {
        heroHeld = false;
        revealHero(0);
      }
      if (t < DONE) {
        window.requestAnimationFrame(step);
        return;
      }
      introFade = 1;
      introTurn = 0;
      entryOn = false;
      if (brand) brand.style.opacity = '';
      if (flight && entryMark.parentNode) entryMark.parentNode.removeChild(entryMark);
      stage.classList.remove('is-entry');
      window.removeEventListener('wheel', skip, opts);
      window.removeEventListener('touchstart', skip, opts);
      window.removeEventListener('keydown', skip);
      window.removeEventListener('pointerdown', skip, opts);
      lastQ = NaN;
      kick();
    }
    window.requestAnimationFrame(step);
  }

  /* ------------------------------------------------------------------ quick buy */
  var over = document.querySelector('.a2s-journey-over');
  var dlg = document.getElementById('sj-qb');
  var form = dlg ? dlg.querySelector('[data-sj-qb-form]') : null;
  var qbImg = dlg && dlg.querySelector('[data-sj-qb-img]');
  var qbNo = dlg && dlg.querySelector('[data-sj-qb-no]');
  var qbName = dlg && dlg.querySelector('[data-sj-qb-name]');
  var qbPrice = dlg && dlg.querySelector('[data-sj-qb-price]');
  var qbChips = dlg && dlg.querySelector('[data-sj-qb-chips]');
  var qbAdd = dlg && dlg.querySelector('[data-sj-qb-add]');
  var qbMore = dlg && dlg.querySelector('[data-sj-qb-more]');
  var qbMsg = dlg && dlg.querySelector('[data-sj-qb-msg]');
  var qbClose = dlg && dlg.querySelector('[data-sj-qb-close]');
  var toasts = over ? over.querySelector('[data-sj-toasts]') : null;
  var current = -1;
  var opener = null;
  var busy = false;
  var SIZE = 'a2-size';

  function selected() {
    var c = qbChips.querySelector('input:checked');
    if (!c) return null;
    var p = products[current];
    for (var i = 0; i < p.variants.length; i++) if (String(p.variants[i].id) === c.value) return p.variants[i];
    return null;
  }
  function updateAdd() {
    if (busy) return;
    var v = selected();
    qbAdd.disabled = !v;
    qbAdd.textContent = v ? 'Add to cart · ' + v.price : 'Pick a size';
  }
  function openBuy(i, from, byKey) {
    var p = products[i];
    if (!p || !dlg || typeof dlg.showModal !== 'function') {
      if (p) window.location.href = p.url;
      return;
    }
    current = i;
    opener = from || null;
    qbImg.src = p.img;
    qbImg.alt = p.title;
    qbNo.textContent = pad(i + 1) + ' / ' + pad(N) + (p.color ? ' · ' + p.color : '');
    qbName.textContent = p.title;
    qbPrice.textContent = (p.varies ? 'From ' : '') + p.price;
    qbMore.href = p.url;
    qbMore.setAttribute('aria-label', 'Full details: ' + p.title);
    qbMsg.textContent = '';
    qbMsg.classList.remove('is-error');
    qbChips.textContent = '';
    var remembered = null;
    try {
      remembered = window.localStorage.getItem(SIZE);
    } catch (e) {}
    var avail = p.variants.filter(function (v) {
      return v.available;
    });
    p.variants.forEach(function (v) {
      var lab = document.createElement('label');
      lab.className = 'sj-chip';
      var inp = document.createElement('input');
      inp.type = 'radio';
      inp.name = 'sj-size';
      inp.value = String(v.id);
      inp.disabled = !v.available;
      if (!v.available) inp.setAttribute('aria-label', v.label + ', unavailable');
      if (v.available && (avail.length === 1 || (remembered && remembered === v.label))) inp.checked = true;
      var span = document.createElement('span');
      span.textContent = v.label;
      lab.appendChild(inp);
      lab.appendChild(span);
      qbChips.appendChild(lab);
    });
    busy = false;
    updateAdd();
    document.documentElement.classList.add('sj-lock');
    dlg.showModal();
    // keyboard users land on the sizes; a tap or click starts on the panel, so no size looks picked
    var first = qbChips.querySelector('input:checked') || qbChips.querySelector('input:not(:disabled)');
    if (byKey && first) first.focus({ preventScroll: true });
    else form.focus({ preventScroll: true });
    window.requestAnimationFrame(function () {
      dlg.classList.add('is-open');
    });
  }
  function closeBuy() {
    if (!dlg || !dlg.open) return;
    dlg.classList.remove('is-open');
    window.setTimeout(
      function () {
        if (dlg.open) dlg.close();
      },
      reduced ? 0 : 340
    );
  }
  if (dlg) {
    dlg.addEventListener('close', function () {
      dlg.classList.remove('is-open');
      document.documentElement.classList.remove('sj-lock');
      if (opener && opener.isConnected && opener.focus) opener.focus({ preventScroll: true });
    });
    dlg.addEventListener('cancel', function (e) {
      e.preventDefault();
      closeBuy();
    });
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg) closeBuy();
    });
    qbClose.addEventListener('click', closeBuy);
    qbChips.addEventListener('change', function () {
      var v = selected();
      if (v) {
        try {
          window.localStorage.setItem(SIZE, v.label);
        } catch (e) {}
      }
      qbMsg.textContent = '';
      qbMsg.classList.remove('is-error');
      updateAdd();
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = selected();
      if (!v || busy) return;
      busy = true;
      var p = products[current];
      qbAdd.disabled = true;
      qbAdd.textContent = 'Adding…';
      addToCart(v.id)
        .then(function (res) {
          qbAdd.textContent = 'Added ✓';
          qbMsg.textContent = p.title + (p.variants.length > 1 ? ', ' + v.label : '') + ' is in your cart.';
          window.setTimeout(function () {
            busy = false;
            closeBuy();
            window.setTimeout(function () {
              var note = function () {
                toast(p.title + (p.variants.length > 1 ? ', ' + v.label : '') + ' is in your cart.');
              };
              if (res && res.drawer) openDrawer(note);
              else note();
            }, 380);
          }, 650);
        })
        .catch(function (err) {
          busy = false;
          qbMsg.textContent = (err && err.message) || 'Could not add this shirt. Try again.';
          qbMsg.classList.add('is-error');
          updateAdd();
        });
    });
  }

  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-sj-buy]');
    if (!b) return;
    openBuy(parseInt(b.getAttribute('data-sj-buy'), 10) || 0, b, e.detail === 0);
  });

  function addToCart(id) {
    var fd = new FormData();
    fd.append('id', String(id));
    fd.append('quantity', '1');
    var items = document.querySelector('cart-drawer-component cart-items-component');
    var sid = items && items.dataset ? items.dataset.sectionId : '';
    if (sid) {
      fd.append('sections', sid);
      fd.append('sections_url', window.location.pathname);
    }
    var added;
    return fetch(shopRoot + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd,
    })
      .then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw new Error(j.description || j.message || 'Could not add this shirt.');
          added = j;
          return fetch(shopRoot + 'cart.js', { headers: { Accept: 'application/json' } });
        });
      })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        // the drawer lives in the header section; if the add response came without it, render it once more
        if (!sid || (added && added.sections && added.sections[sid])) return cart;
        return fetch(shopRoot + '?section_id=' + encodeURIComponent(sid), { headers: { Accept: 'text/html' } })
          .then(function (r) {
            return r.ok ? r.text() : '';
          })
          .then(function (html) {
            if (html && html.indexOf('shopify-section-' + sid) >= 0) {
              added = added || {};
              added.sections = {};
              added.sections[sid] = html;
            }
            return cart;
          })
          .catch(function () {
            return cart;
          });
      })
      .then(function (cart) {
        var ev = new Event('cart:update', { bubbles: true });
        var data = { itemCount: cart.item_count, source: 'a2s-journey' };
        if (added && added.sections) data.sections = added.sections;
        ev.detail = { resource: cart, sourceId: 'a2s-journey', data: data };
        document.dispatchEvent(ev);
        // the drawer only opens when it has the new cart to show
        return { cart: cart, drawer: !!(data.sections && sid && data.sections[sid]) };
      });
  }
  function openDrawer(fallback) {
    var d = document.querySelector('cart-drawer-component');
    if (!d || typeof d.showDialog !== 'function') {
      fallback();
      return;
    }
    try {
      if (!d.querySelector('dialog[open]')) d.showDialog();
    } catch (e) {}
    window.setTimeout(function () {
      if (!document.querySelector('cart-drawer-component dialog[open]')) fallback();
    }, 700);
  }
  function toast(text) {
    if (!toasts) return;
    var t = document.createElement('div');
    t.className = 'sj-toast';
    var s = document.createElement('span');
    s.textContent = text;
    var a = document.createElement('a');
    a.href = shopRoot + 'cart';
    a.textContent = 'View cart';
    t.appendChild(s);
    t.appendChild(a);
    toasts.appendChild(t);
    window.setTimeout(function () {
      t.remove();
    }, 5200);
  }

  /* ------------------------------------------------------------------ reveal + misc */
  var reveals = $$('[data-sj-reveal]');
  if (reduced || !('IntersectionObserver' in window)) {
    reveals.forEach(function (el) {
      el.classList.add('is-in');
    });
  } else {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          en.target.classList.add('is-in');
          io.unobserve(en.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px' }
    );
    reveals.forEach(function (el) {
      io.observe(el);
    });
  }
  var top = $('[data-sj-top]');
  if (top) {
    top.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
    });
  }

  /* ------------------------------------------------------------------ start */
  var rt = 0;
  window.addEventListener(
    'resize',
    function () {
      window.clearTimeout(rt);
      rt = window.setTimeout(layout, 120);
    },
    { passive: true }
  );
  window.addEventListener('scroll', kick, { passive: true });
  layout();
  P = targetP();
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () {
      layout();
    });
  }
  runEntry();
  kick();
})();
